import { useEffect, useState } from "react";
import axios from "axios";
import { KeyRound, ChevronDown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (d) => (d ? new Date(d).toLocaleString("sk-SK", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
const KIND = {
  certified: "Zdarma – certifikovaná", granted: "Zdarma – pridelené ručne", paid: "Registrovaná – 20 € (24 h)",
  expired: "Registrovaná – 20 € (24 h)", none: "Registrovaná – 20 € (24 h)", guest: "Bez registrácie – 50 € (24 h)",
};

export default function AdminSearchAccess({ token }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(true);
  useEffect(() => {
    axios.get(`${API}/admin/search-access`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  }, [token]);
  const active = (rows || []).filter((r) => r.access).length;
  return (
    <div className="border border-[#D4AF37]/30 bg-[#0a0a0a] mb-8" data-testid="admin-search-access">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between px-5 py-4" data-testid="admin-search-access-toggle">
        <span className="flex items-center gap-2 font-display text-lg"><KeyRound size={17} className="text-[#D4AF37]" /> Predané prístupy do databázy kandidátov</span>
        <span className="flex items-center gap-3 text-xs text-white/50">aktívne {active} / spolu {(rows || []).length} <ChevronDown size={15} className={`transition-transform ${open ? "rotate-180" : ""}`} /></span>
      </button>
      {open && (
        <div className="px-5 pb-5 overflow-x-auto">
          {rows && rows.length === 0 && <p className="text-white/40 text-sm" data-testid="admin-search-access-empty">Zatiaľ žiadne prístupy.</p>}
          {rows && rows.length > 0 && (
            <table className="w-full text-sm">
              <thead><tr className="text-left text-white/40 text-xs uppercase tracking-wider">
                <th className="py-2 pr-4">Firma</th><th className="pr-4">E-mail</th><th className="pr-4">Typ</th><th className="pr-4">Zaplatené</th><th className="pr-4">Platí do</th><th>Stav</th>
              </tr></thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i} className="border-t border-white/5" data-testid={`search-access-row-${i}`}>
                    <td className="py-2 pr-4 text-white">{r.name || "—"}</td>
                    <td className="pr-4 text-white/60">{r.email}</td>
                    <td className="pr-4 text-white/70">{KIND[r.reason] || r.reason}{r.from_guest ? " · z platby 50 €" : ""}{r.upgraded ? " · zaregistrovaná" : ""}{r.email_verified === false ? " · e-mail nepotvrdený" : ""}</td>
                    <td className="pr-4 text-white/50">{r.reason === "certified" || r.reason === "granted" ? "—" : fmt(r.paid_at)}</td>
                    <td className="pr-4 text-white/50">{r.reason === "certified" || r.reason === "granted" ? "bez obmedzenia" : fmt(r.until)}</td>
                    <td className={r.access ? "text-emerald-300" : "text-white/35"}>{r.access ? "aktívny" : "vypršal"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
